export const roundToNearestStep = (value: number, step: number, base = 0): number => {
  if (!Number.isFinite(step) || step <= 0) return Math.round(value);
  return base + Math.round((value - base) / step) * step;
};

const FLOATING_POINT_TOLERANCE = 1e-9;

const countDecimals = (n: number): number => /\.(\d+)$/.exec(n.toString())?.[1].length ?? 0;

const roundToPrecision = (n: number, decimals: number): number => {
  const factor = 10 ** decimals;
  return Math.round(n * factor) / factor;
};

export const ceilToStep = (value: number, step: number, base = 0): number => {
  if (!Number.isFinite(step) || step <= 0) return Math.ceil(value);
  const steps = Math.ceil((value - base) / step - FLOATING_POINT_TOLERANCE);
  const result = base + steps * step;
  const decimals = Math.max(countDecimals(step), countDecimals(base));
  return decimals > 0 ? roundToPrecision(result, decimals) : result;
};

export const getStepAlignedMaximum = (max: number, step: number, base = 0): number => {
  if (!Number.isFinite(max) || !Number.isFinite(step) || step <= 0) return max;
  return base + Math.floor((max - base) / step) * step;
};

export const toNumberOrNull = (v: string | number): number | null => {
  if (typeof v === 'number') return Number.isFinite(v) ? v : null;
  const parsed = Number(v.toString().replace(',', '.'));
  return Number.isFinite(parsed) ? parsed : null;
};

export const toRouteParamNumberOrNull = (v: unknown): number | null => {
  if (Array.isArray(v)) {
    return v.length > 0 ? toNumberOrNull(v[0]) : null;
  }

  if (typeof v !== 'string' && typeof v !== 'number') return null;
  return toNumberOrNull(v);
};
